/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Select, SelectOption,
    Button,
} from 'appkit-react';
import { Row, Col } from 'react-bootstrap';

import ConfigWarningModal from './ConfigWarningModal';

const suggestedOperations = [{ id: 1, name: 'Sum' }];

const containerStyle = { display: 'flex', alignItems: 'center' };
const spanStyle = {
    marginLeft: '5px',
    paddingLeft: '5px',
    fontSize: '10px',
    color: '#D04A02',
    fontStyle: 'italic',
};

/**
    * @param selectionName as recommended column name
    * @returns div component for each selection option where column name matches recommended column name
    */
const getBadge = selectionName => (
    <div style={containerStyle}>
        {selectionName}
        <span style={spanStyle}>recommended</span>
    </div>
);

/**
     * @returns select options for source column
     */
const sourceColSelectOptions = (data, relation) => data[0].selectedColumns.filter(sc => sc.dataType === 'number').map(({ column }, index) => {
    if (column === relation.source_col) {
        return <SelectOption key={`src_col_${index}`} value={column}>{getBadge(column)}</SelectOption>;
    }
    return <SelectOption key={`src_col_${index}`} value={column}>{column}</SelectOption>;
});

/**
     * @returns select options for target column
     */
const targetColSelectOptions = (data, relation) => data[1].selectedColumns.filter(sc => sc.dataType === 'number').map(({ column }, index) => {
    if (column === relation.target_col) {
        return <SelectOption key={`trg_col_${index}`} value={column}>{getBadge(column)}</SelectOption>;
    }
    return <SelectOption key={`trg_col_${index}`} value={column}>{column}</SelectOption>;
});

/**
 * @returns select options for source group by column
 */
const sourceGroupColSelectOptions = (data, relation) => data[0].selectedColumns.map(({ column }, index) => {
    if (relation.source_groupby_col && relation.source_groupby_col.includes(column)) {
        return <SelectOption key={`src_grp_${index}`} value={column}>{getBadge(column)}</SelectOption>;
    }
    return <SelectOption key={`src_grp_${index}`} value={column}>{column}</SelectOption>;
});

/**
     * @returns select options for target group by column
     */
const targetGroupColSelectOptions = (data, relation) => data[1].selectedColumns.map(({ column }, index) => {
    if (relation.target_groupby_col && relation.target_groupby_col.includes(column)) {
        return <SelectOption key={`trg_grp_${index}`} value={column}>{getBadge(column)}</SelectOption>;
    }
    return <SelectOption key={`trg_grp_${index}`} value={column}>{column}</SelectOption>;
});

const DataSuggestionModal = ({
    showSuggestionModal, setShowSuggestionModal, selectedOperation, selectedRelation,
    updatedConfigData, sourceCol, targetCol, sourceGroupBy, targetGroupBy,
    showWarningModal, onSelectOperation, onSourceColSelected, onTargetColSelected,
    onSourceGroupBySelected, onTargetGroupBySelected, setConfirm, handleConfirm,
    setShowWarningModal,
}) => (
    <>
        <div>
            {showWarningModal && (
                <ConfigWarningModal
                    showWarningModal={showWarningModal}
                    setShowWarningModal={setShowWarningModal}
                    setConfirm={setConfirm}
                />
            )}
        </div>
        <div className="true-comply-data-relationship-suggesstion_modal">
            <Modal
                className="form-modal"
                visible={showSuggestionModal}
                onCancel={() => setShowSuggestionModal(false)}
                style={{ width: '500px' }}
            >
                <ModalHeader>
                    <div className="a-modal-header">
                        <div className="modal-title-left">
                            <div className="modal-title">RECON CONFIGURATION</div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div className="modal-form-container">
                        <div className="modal-form-operation-select">
                            <label className="form-label">
                                SELECT OPERATION
                                <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                            </label>
                            <Select
                                placeholder="Select"
                                onSelect={e => { onSelectOperation(e); }}
                                value={selectedOperation}
                                name="operation"
                                disabled={selectedOperation === 'Sum'}
                            >
                                {
                                    suggestedOperations.map(({ id, name }) => <SelectOption key={id} value={name}>{name}</SelectOption>)
                                }
                            </Select>
                        </div>
                        <Row>
                            <Col md={6}>
                                <div className="modal-form-source_column_select">
                                    <label className="form-label">
                                        SOURCE COLUMN
                                        <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                                    </label>
                                    <Select
                                        placeholder="Select"
                                        // size="large"
                                        onSelect={e => { onSourceColSelected(e); }}
                                        value={sourceCol}
                                        name="source_col"
                                    >
                                        {sourceColSelectOptions(updatedConfigData, selectedRelation)}
                                    </Select>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="modal-form-target_column_select">
                                    <label className="form-label">
                                        TARGET COLUMN
                                        <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                                    </label>
                                    <Select
                                        placeholder="Select"
                                        onSelect={e => { onTargetColSelected(e); }}
                                        value={targetCol}
                                        name="target_col"
                                    >
                                        {targetColSelectOptions(updatedConfigData, selectedRelation)}
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="modal-form-source_groupby_select">
                                    <label className="form-label"> SOURCE GROUPBY </label>
                                    <Select
                                        placeholder="Select"
                                        onSelect={e => { onSourceGroupBySelected(e); }}
                                        value={sourceGroupBy}
                                        name="source_grp_by"
                                        multiple
                                    >
                                        {sourceGroupColSelectOptions(updatedConfigData, selectedRelation)}
                                    </Select>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="modal-form-target_groupby_select">
                                    <label className="form-label"> TARGET GROUPBY </label>
                                    <Select
                                        placeholder="Select"
                                        multiple
                                        onSelect={e => { onTargetGroupBySelected(e); }}
                                        value={targetGroupBy}
                                        name="target_grp_by"
                                    >
                                        {targetGroupColSelectOptions(updatedConfigData, selectedRelation)}
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="flex-fill help-text">
                        Skip suggested configuration?
                        <span
                            style={{
                                cursor: 'pointer',
                                marginLeft: '0.3rem',
                                color: '#c52a1a',
                                fontWeight: 'bold',
                            }}
                            onClick={() => handleConfirm(true)}
                            role="presentation"
                        >
                            Click Here
                        </span>
                    </div>
                    <div className="button-comp">
                        <Button kind="transparent" gray onClick={() => setShowSuggestionModal(false)} size="lg"> CANCEL </Button>
                        <Button kind="primary" onClick={() => handleConfirm(false)} size="lg" disabled={sourceCol === '' || targetCol === ''}> PROCEED</Button>
                    </div>
                </ModalFooter>
            </Modal>
        </div>
    </>
);

export default DataSuggestionModal;
